export const ADDRESS_CHANGE = {
    "Hai Ba Trung": {
        name: "CHI NHÁNH HAI BÀ TRƯNG - CÔNG TY CỔ PHẦN KHÁCH SẠN AZUMAYA",
        address: "Số 16 Bùi Thị Xuân, Phường Hai Bà Trưng, Thành phố Hà Nội, Việt Nam",
        phone: "Điện thoại: (024) 6278 6688"
    },
    "Linh Lang": {
        name: "CHI NHÁNH LINH LANG - CÔNG TY CỔ PHẦN KHÁCH SẠN AZUMAYA",
        address: "Số 26, phố Linh Lang, Phường Ngọc Hà, Thành phố Hà Nội, Việt Nam",
        phone: "Điện thoại: (024) 38620 620"
    },
    "Kim Ma 2": {
        name: "CHI NHÁNH KIM MÃ 2 - CÔNG TY CỔ PHẦN KHÁCH SẠN AZUMAYA",
        address: "Số 18A Phạm Huy Thông, Phường Giảng Võ, Thành phố Hà Nội, Việt Nam",
        phone: "Điện thoại: (024) 3724 7570"
    },
    "Kim Ma 3": {
        name: "CHI NHÁNH KIM MÃ 3 - CÔNG TY CỔ PHẦN KHÁCH SẠN AZUMAYA",
        address: "Số 68 Phạm Huy Thông, Phường Giảng Võ, Thành phố Hà Nội, Việt Nam",
        phone: "Điện thoại: (024) 37 349 730"
    },
    "Dao Tan": {
        name: "CHI NHÁNH ĐÀO TẤN - CÔNG TY CỔ PHẦN KHÁCH SẠN AZUMAYA",
        address: "Số 82 Đào Tấn, phường Giảng Võ, Thành phố Hà Nội, Việt Nam",
        phone: "Điện thoại: (024) 0397 666 890"
    },
    "Hai Phong": {
        name: "CHI NHÁNH HẢI PHÒNG VŨ TRỌNG KHÁNH - CÔNG TY CỔ PHẦN KHÁCH SẠN AZUMAYA",
        address: "Số 195 đường Vũ Trọng Khánh, Phường Gia Viên, Thành phố Hải Phòng, Việt Nam",
        phone: "Điện thoại: 0225 3828 969"
    },
    "Da Nang": {
        name: "CHI NHÁNH ĐÀ NẴNG NGUYỄN TẤT THÀNH – CÔNG TY CỔ PHẦN KHÁCH SẠN AZUMAYA",
        address: "31 Nguyễn Tất Thành ,Phường Hải Châu ,TP. Đà Nẵng",
        phone: "Điện thoại: (0236) 3 743 888"
    },
    "Thai Van Lung 1":{
        name: "CÔNG TY CỔ PHẦN KHÁCH SẠN AZUMAYA",
        address: "8A/7D1-8A/8D1-8A/9D1 Thái Văn Lung, Phường Sài Gòn, TP.HCM",
        phone: "Điện thoại: (028) 3824 6835"
    },
    "Le Thanh Ton":{
        name: "CHI NHÁNH CÔNG TY CỔ PHẦN KHÁCH SẠN AZUMAYA",
        address: "15/3  Lê Thánh Tôn , Phường Sài Gòn, TP.HCM",
        phone: "Điện thoại: (028) 3827 1110"
    },
    "Thai Van Lung 2":{
        name: "CHI NHÁNH THÁI VĂN LUNG 2 - CÔNG TY CỔ PHẦN KHÁCH SẠN AZUMAYA",
        address: "27-29 Thái Văn Lung, Phường Sài Gòn, TP.HCM",
        phone: "Điện thoại: (028) 3827 1071"
    },
    "Azumaya": {
        name: "CÔNG TY CỔ PHẦN KHÁCH SẠN AZUMAYA",
        address: "",
        phone: ""
    }
}

export const BANK_ACCOUNT = {
    "Hai Ba Trung VND": {
        accountName: "CHI NHÁNH HAI BÀ TRƯNG - CÔNG TY CỔ PHẦN KHÁCH SẠN AZUMAYA",
        accountNumber: "06111 005 08 008",
        bankName:"Ngân hàng Thương mại Cổ phần Quân Đội (MB) - Chi nhánh Hoàn Kiếm, Hà Nội",
        swiftCode:"MSCBVNVX"
                //Ngân hàng Thương mại Cổ phần Quân Đội (MB) - Chi nhánh Hoàn Kiếm, Hà Nội	 	 	 	 	 
    },
    "Hai Ba Trung USD": {
        accountName: "CHI NHANH HAI BA TRUNG - CONG TY CO PHAN KHACH SAN AZUMAYA",
        accountNumber: "1440193801",
        bankName: "Joint Stock Commercial Bank for Investment and Development of Vietnam - Branch: Thong Nhat",
        bankAddress: "Saigon Plaza No 24, Le Thanh Ton Street, Sai Gon Ward, Ho Chi Minh City, Viet Nam",
        swiftCode:"BIDVVNVX"
    }, 
    "Hai Ba Trung YEN": {
        accountName: "CHI NHANH HAI BA TRUNG - CONG TY CO PHAN KHACH SAN AZUMAYA",
        accountNumber: "1440193801",
        bankName: "Joint Stock Commercial Bank for Investment and Development of Vietnam - Branch: Thong Nhat",
        bankAddress: "Saigon Plaza No 24, Le Thanh Ton Street, Sai Gon Ward, Ho Chi Minh City, Viet Nam",
        swiftCode:"BIDVVNVX"
    }, 
    "Kim Ma 2 VND": {
        accountName: "CHI NHÁNH KIM MÃ 2 - CÔNG TY CỔ PHẦN KHÁCH SẠN AZUMAYA",
        accountNumber: "2200 587 162",
        bankName: "Ngân hàng  TMCP Đầu tư và Phát triển Việt Nam (BIDV)- Chi nhánh Thăng Long",
        swiftCode:"BIDVVNVX"
    }, 
    "Kim Ma 2 USD": {
        accountName: "CHI NHANH KIM MA 2 - CONG TY CO PHAN KHACH SAN AZUMAYA",
        accountNumber: "2200 587 162",
        bankName: "JOINT STOCK COMMERCIAL BANK FOR INVESTMENT AND DEVELOPMENT OF VIETNAM",
        bankAddress: "No 3, Pham Hung street, Cau Giay ward, Hanoi, Vietnam",
        swiftCode: "BIDVVNVX"
    }, 
    "Kim Ma 2 YEN": {
        accountName: "CHI NHANH KIM MA 2 - CONG TY CO PHAN KHACH SAN AZUMAYA",
        accountNumber: "2200 587 162",
        bankName: "JOINT STOCK COMMERCIAL BANK FOR INVESTMENT AND DEVELOPMENT OF VIETNAM",
        bankAddress: "No 3, Pham Hung street, Cau Giay ward, Hanoi, Vietnam",
        swiftCode: "BIDVVNVX"
    }, 
    "Kim Ma 3 VND": {
        accountName: "CHI NHÁNH KIM MÃ 3 - CÔNG TY CỔ PHẦN KHÁCH SẠN AZUMAYA",
        accountNumber: "086 1101 196 009",
        bankName: "Ngân hàng Thương mại Cổ phần Quân Đội (MB) - Chi nhánh Ba Đình - Hà Nội",
        swiftCode: "MSCBVNVX"
    },
    "Kim Ma 3 USD": {
        accountName: "CHI NHANH KIM MA 3 - CONG TY CO PHAN KHACH SAN AZUMAYA",
        accountNumber: "1440299781", 
        bankName: "Joint Stock Commercial Bank for Investment and Development of Vietnam - Branch: Thong Nhat",
        bankAddress: "Saigon Plaza No 24, Le Thanh Ton Street, Sai Gon Ward, Ho Chi Minh City, Viet Nam",
        swiftCode: "BIDVVNVX"
    },
    "Kim Ma 3 YEN": {
        accountName: "CHI NHANH KIM MA 3 - CONG TY CO PHAN KHACH SAN AZUMAYA",
        accountNumber: "1440299781", 
        bankName: "Joint Stock Commercial Bank for Investment and Development of Vietnam - Branch: Thong Nhat",
        bankAddress: "Saigon Plaza No 24, Le Thanh Ton Street, Sai Gon Ward, Ho Chi Minh City, Viet Nam",
        swiftCode: "BIDVVNVX"
    },
    "Linh Lang VND": {
        accountName: "CHI NHÁNH LINH LANG - CÔNG TY CỔ PHẦN KHÁCH SẠN AZUMAYA",
        accountNumber: "086 1100 898 007",
        bankName: "Ngân hàng Thương mại Cổ phần Quân Đội (MB) - Chi nhánh Ba Đình - Hà Nội",
        swiftCode: "MSCBVNVX"
    }, 
    "Linh Lang USD": {
        accountName: "CHI NHANH LINH LANG - CONG TY CO PHAN KHACH SAN AZUMAYA",
        accountNumber: "1440198480",
        bankName: "Joint Stock Commercial Bank for Investment and Development of Vietnam - Branch: Thong Nhat",
        bankAddress: "Saigon Plaza No 24, Le Thanh Ton Street, Sai Gon Ward, Ho Chi Minh City, Viet Nam",
        swiftCode: "BIDVVNVX"
    }, 
    "Linh Lang YEN": {
        accountName: "CHI NHANH LINH LANG - CONG TY CO PHAN KHACH SAN AZUMAYA",
        accountNumber: "1440198480",
        bankName: "Joint Stock Commercial Bank for Investment and Development of Vietnam - Branch: Thong Nhat",
        bankAddress: "Saigon Plaza No 24, Le Thanh Ton Street, Sai Gon Ward, Ho Chi Minh City, Viet Nam",
        swiftCode: "BIDVVNVX"
    },
    "Dao Tan VND": {
        accountName: "CHI NHÁNH ĐÀO TẤN - CÔNG TY CỔ PHẦN KHÁCH SẠN AZUMAYA",
        accountNumber: "862 005 3224",
        bankName: "TMCP Đầu tư và Phát triển Việt Nam (BIDV)- Chi nhánh Thống Nhất",
        swiftCode: "BIDVVNVX"
    }, 
    "Dao Tan USD": {
        accountName: "CHI NHANH DAO TAN - CONG TY CO PHAN KHACH SAN AZUMAYA",
        accountNumber: "862 005 3224",
        bankName: "Joint Stock Commercial Bank for Investment and Development of Vietnam - Branch: Thong Nhat",
        bankAddress: "Saigon Plaza No 24, Le Thanh Ton Street, Sai Gon Ward, Ho Chi Minh City, Viet Nam",
        swiftCode: "BIDVVNVX"
    }, 
    "Dao Tan YEN": {
        accountName: "CHI NHANH DAO TAN - CONG TY CO PHAN KHACH SAN AZUMAYA",
        accountNumber: "862 005 3224",
        bankName: "Joint Stock Commercial Bank for Investment and Development of Vietnam - Branch: Thong Nhat - Ho Chi Minh City",
        bankAddress: "Saigon Plaza No 24, Le Thanh Ton Street, Sai Gon Ward, Ho Chi Minh City, Viet Nam",
        swiftCode: "BIDVVNVX"
    }, 
    "Hai Phong VND": {
        accountName: "CHI NHÁNH HẢI PHÒNG VŨ TRỌNG KHÁNH - CÔNG TY CỔ PHẦN KHÁCH SẠN AZUMAYA",
        accountNumber: "1440407946",
        bankName: "BIDV - Chi nhánh Thống Nhất, TP Hồ Chí Minh",
        swiftCode:"BIDVVNVX"
    },  
    "Hai Phong USD": {
        accountName: "CHI NHANH HAI PHONG VU TRONG KHANH - CONG TY CO PHAN KHACH SAN AZUMAYA",
        accountNumber: "1440407946",
        bankName: "BIDV - Chi nhánh Thống Nhất, TP Hồ Chí Minh",
        bankAddress: "",
        swiftCode:"BIDVVNVX"
    },
    "Hai Phong YEN": {
        accountName: "CHI NHANH HAI PHONG VU TRONG KHANH - CONG TY CO PHAN KHACH SAN AZUMAYA",
        accountNumber: "1440407946",
        bankName: "BIDV - Chi nhánh Thống Nhất, TP Hồ Chí Minh",
        bankAddress: "Address: Toà nhà Saigon Plaza, 24 Lê Thánh Tôn, phường Sài Gòn, TP HCM",
        swiftCode:"BIDVVNVX"
    },
    "Da Nang VND": {
        accountName: "Chi nhánh Đà Nẵng Nguyễn Tất Thành – Công ty Cổ Phần Khách Sạn Azumaya",
        accountNumber: "1440412278",
        bankName: "BIDV - Chi nhánh Thống Nhất, TP Hồ Chí Minh",
        swiftCode:"BIDVVNVX"
    }, 
    "Da Nang USD": {
        accountName: "",
        accountNumber: "",
        bankName: "",
        bankAddress: "",
        swiftCode:""
    }, 
    "Thai Van Lung 1 VND": {
        accountName: "CÔNG TY CỔ PHẦN KHÁCH SẠN AZUMAYA",
        accountNumber: "1440221845",
        bankName: "BIDV_ Chi Nhánh Thống Nhất",
        swiftCode:"BIDVVNVX"
    }, 
    "Thai Van Lung 1 USD": {
        accountName: "CÔNG TY CỔ PHẦN KHÁCH SẠN AZUMAYA",
        accountNumber: "1440007304",
        bankName: "BIDV_ Chi Nhánh Thống Nhất",
        bankAddress: "",
        swiftCode:"BIDVVNVX"
    }, 
    "Thai Van Lung 2 VND": {
        accountName: "CHI NHÁNH THÁI VĂN LUNG 2 - CÔNG TY CỔ PHẦN KHÁCH SẠN AZUMAYA",
        accountNumber: "8690083053",
        bankName: "BIDV- CN Thống Nhất",
        swiftCode:"BIDVVNVX"
    }, 
    "Thai Van Lung 2 USD": {
        accountName: "CHI NHÁNH THÁI VĂN LUNG 2 - CÔNG TY CỔ PHẦN KHÁCH SẠN AZUMAYA",
        accountNumber: "250874209",
        bankName: "BIDV- CN Thống Nhất",
        bankAddress: "",
        swiftCode:"BIDVVNVX"
    }, 
    "Le Thanh Ton VND": {
        accountName: "CHI NHÁNH CÔNG TY CỔ PHẦN KHÁCH SẠN AZUMAYA",
        accountNumber: "1440221854",
        bankName: "BIDV_ Chi Nhánh Thống Nhất",
        swiftCode:"BIDVVNVX"
    }, 
    "Le Thanh Ton USD": {
        accountName: "CHI NHÁNH CÔNG TY CỔ PHẦN KHÁCH SẠN AZUMAYA",
        accountNumber: "1440007368",
        bankName: "BIDV_ Chi Nhánh Thống Nhất",
        bankAddress: "",
        swiftCode:"BIDVVNVX"
    }, 
    "Azumaya VND": {
        accountName: "CÔNG TY TNHH MỘT THÀNH VIÊN KHÁCH SẠN AZUMAYA",
        accountNumber: "",
        baneName: "",
        bankAddress: "",
        swiftCode:"BIDVVNVX"
    },
    "Azumaya USD": {
        accountName: "CÔNG TY TNHH MỘT THÀNH VIÊN KHÁCH SẠN AZUMAYA",
        accountNumber: "",
        bankName: "",
        bankAddress: "",
        swiftCode:""
    }
}
